import localeSlice from 'reducers/locale/reducer';

const { actions, reducer } = localeSlice;

export const localeActions = actions;

export default reducer;
